<div
  class="flex max-h-[90vh] flex-col overflow-hidden rounded-2xl bg-card shadow-xl dark:bg-zinc-900"
  [overlayLoader]="saving() || uploading()">
  <div
    class="dialog-header sticky top-0 z-10 shrink-0 !m-0 !px-6 !py-4 bg-primary text-white shadow-sm flex items-start justify-between gap-3">
    <div class="flex items-center gap-3 min-w-0">
      <div class="w-11 h-11 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
        <mat-icon class="icon-size-6 !text-white" [svgIcon]="'heroicons_outline:paper-clip'"></mat-icon>
      </div>
      <div class="dialog-title min-w-0">
        <h2 class="!text-white !m-0 text-lg font-bold tracking-tight">Submit payment proof</h2>
        <p class="dialog-subtitle !text-white/80 !m-0 text-sm mt-0.5 truncate">
          {{ titleHint }}
        </p>
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      class="!text-white hover:!bg-white/10 shrink-0"
      aria-label="Close"
      (click)="cancel()">
      <mat-icon class="!text-white" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>
  </div>

  <mat-dialog-content class="!m-0 min-h-0 flex-1 overflow-y-auto !px-6 !py-5 min-w-0">
    <form [formGroup]="form" class="flex flex-col gap-3 min-w-0">
      <mat-form-field class="fuse-mat-dense w-full min-w-0" subscriptSizing="dynamic">
        <mat-label>Amount</mat-label>
        <input matInput type="number" min="0" step="0.01" formControlName="amount" />
      </mat-form-field>

      <mat-form-field class="fuse-mat-dense w-full min-w-0" subscriptSizing="dynamic">
        <mat-label>Remarks</mat-label>
        <textarea matInput rows="2" formControlName="remarks" placeholder="Optional"></textarea>
      </mat-form-field>

      <div
        class="flex flex-col gap-2 rounded-lg border border-neutral-200 dark:border-neutral-700 px-3 py-2.5 min-w-0">
        <div class="flex items-center gap-3 min-w-0">
          <input #fileInput type="file" class="hidden" (change)="onFileChange($event)" />
          <button mat-stroked-button type="button" [disabled]="uploading()" (click)="fileInput.click()">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:paper-clip'"></mat-icon>
            <span class="ms-2">{{ fileName() ? 'Replace file' : 'Attach proof' }}</span>
          </button>
          @if (fileName(); as name) {
            <span class="min-w-0 flex-1 truncate text-sm text-secondary">{{ name }}</span>
            <button mat-icon-button type="button" aria-label="Remove file" (click)="removeFile()">
              <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
          } @else {
            <span class="text-sm text-secondary">Required</span>
          }
        </div>
        @if (form.get('fileAttachmentId')?.hasError('required') && form.get('fileAttachmentId')?.touched) {
          <p class="text-xs text-red-600 dark:text-red-400 m-0">Payment proof file is required</p>
        }
      </div>
    </form>
  </mat-dialog-content>

  <div class="sticky bottom-0 z-10 shrink-0 bg-card px-6 pb-5 pt-2 dark:bg-zinc-900">
    <mat-dialog-actions align="end" class="!m-0 !p-0 min-h-0 gap-2">
      <button mat-stroked-button type="button" [disabled]="saving()" (click)="cancel()">Cancel</button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="saving() || uploading()"
        (click)="submit()">
        {{ saving() ? 'Submitting…' : 'Submit proof' }}
      </button>
    </mat-dialog-actions>
  </div>
</div>
